<div class="d-flex align-items-stretch shadow-lg rounded overflow-hidden">
  <div class="bg-image-cover bg-dark d-none d-md-block col-md-6 col-xl-8" style="background-image:url('https://source.unsplash.com/800x1000?shopping');"></div>

  <div class="bg-light col-12 col-md-6 col-xl-4">
    <router-outlet></router-outlet>
  </div>
</div>
